var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiUpdateProfessionalHotlineRequestInterviewPhone } from '@/actions/ProfessionalHotlineRequestInterviewActions';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * コンサルホットライン（コンサル側）で電話番号のみ更新するカスタムフック
 */
export const useHotlineProDetailNegotiatePhone = (options) => {
    const { dispatch, id, interviewId, onSuccess, requestId } = options;
    const onSubmitPhone = useCallback((formValue) => __awaiter(void 0, void 0, void 0, function* () {
        if (!requestId || !interviewId) {
            return;
        }
        // 受諾処理を実行
        yield wrapDispatch(dispatch, apiUpdateProfessionalHotlineRequestInterviewPhone({
            json: Object.assign(Object.assign({}, formValue), { time_schedule: null }),
            path: {
                hotline_request_id: requestId,
                hotline_request_interview_id: interviewId,
                id,
            },
        }, {}));
        // 送信後の処理（データ引き直しなどを行う想定）
        yield (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
    }), [dispatch, id, interviewId, onSuccess, requestId]);
    return {
        onSubmitPhone,
    };
};
